import React, {useEffect, useState} from "react";
import Style from "../components/StartNew2.module.css"
import {verifyLogin, getMentorsRating, getAdToShow, traceAdClick} from "../api/UserService";
import {useNavigate} from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import instagram_logo from "../image/Instagram.png";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MentorsCarousel from "./LandingPage/MentorsCarousel";
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import VideoCameraFrontOutlinedIcon from '@mui/icons-material/VideoCameraFrontOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import FilterNoneOutlinedIcon from '@mui/icons-material/FilterNoneOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import MetaphoricCardsModalStartPage from "./methaphoricCards/MetaphoricCardsModalStartPage";
import aboutPlatformPath from "../image/tmp-png/AboutPlatform.png";
import allMentorsPath from "../image/tmp-png/AllMentors.png";
import ReactGA from "react-ga4";
import ReactPlayer from "react-player";
import {useEffectOnce} from "../hooks/useEffectOnce";
import InstagramWarning from "./InstagramWarning";
import TranslationSwitch from "../translation/translationSwitch";
import {useTranslation} from "react-i18next";

function StartPageNew() {
    const [authorised, setAuthorised] = useState(false)
    const [loginVerificationComplete, setLoginVerificationComplete] = useState(false)
    const [metCard, setMetCard] = useState(false)
    const [mentors, setMentors] = useState()
    const nav = useNavigate()

    const [adId, setAdId] = useState(0)
    const [adImgUrl, setAdImgUrl] = useState("https://leela-online-videos.s3.eu-north-1.amazonaws.com/MainGif.gif")
    const [adFollowUrl, setAdFollowUrl] = useState("https://www.instagram.com/leelaonline_net/")
    const { t,i18n } = useTranslation('translation', { keyPrefix: 'startNewPage' });

    function onLoginVerify(authorised) {
        setAuthorised(authorised)
        setLoginVerificationComplete(true)
    }

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    function sendEvent(action, category) {
        ReactGA.event({
            action: action,
            category: category,
            label: "Start page"
        })
    }

    useEffect(() => {
        i18n.language === "en" ? nav("/en") : nav("/")
    },[i18n.language])

    useEffect(() => {
            getMentorsRating(setMentors, () => {
            })
            verifyLogin(onLoginVerify)
        },
        [])

    useEffectOnce(() => {
        getAdToShow(
            (res) => {
                setAdId(res.id)
                setAdImgUrl(res.img_url)
                setAdFollowUrl(res.follow_up_url)
            },
            () => {}
        )
    })

    function verifyLoggedIn() {
        return loginVerificationComplete && authorised
    }

    const controlBox = (imagePath, boxNumber, text, doOnClick) => {
        return (
            <div
                className={
                    boxNumber === 1 ? Style.controlBox1Container :
                        (boxNumber === 2 ? Style.controlBox2Container : Style.controlBox3Container)}>
                <div className={Style.controlBoxParent}
                     onClick={doOnClick}>
                    <div className={Style.controlBox}
                         style={{
                             backgroundImage: "url(" + imagePath + ")",
                         }}>
                        <div className={Style.controlBoxText}>
                            {text && <div>{text}</div>}
                            {!text && [0, 17].includes(adId) && <div style={{
                                padding: "10px",
                                width: "100%",
                                fontSize: "14px",
                                display: "flex",
                                flexDirection:"column",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "flex-end"
                            }}>
                                <div> {t('ads_sales_label')} </div>
                                <a
                                    style={{backgroundColor: "white", textShadow: "none", padding: "3px", borderRadius: "6px"}}
                                    href="mailto:sales@leelaonline.net"
                                    target="_blank"
                                    onClick={(e) => {e.stopPropagation()} }
                                > sales@leelaonline.net</a>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <InstagramWarning/>
            <>
                <div className={Style.startPageMainContainer}>
                    <div className={Style.upperNavBar}>
                            <span className={Style.logoText}
                            >LeelaOnline
                            </span>
                        <div className={Style.prices} onClick={() => sendEvent("open prices", "prices")}>
                            <a href={i18n.language === "en" ? "/price_en" : "/price"} target="_blank">{t('prices')}</a>
                        </div>
                        <div className={Style.videos} onClick={() => sendEvent("open videos", "videos")}>
                            <a href={"https://www.youtube.com/playlist?list=PLXzFMjHpPAd0oyUx8gCJI4kOBmyq-KNGR"}
                               target="_blank">{t('howToUse')}</a>
                        </div>
                        <div className={Style.loginButton}>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{show: 50, hide: 400}}
                                overlay={renderTooltip(verifyLoggedIn() ? t('myCabinet') : t('loginRegister'))}
                            >
                                <AccountCircleIcon
                                    style={{
                                        fontSize: "xx-large",
                                        backgroundColor: verifyLoggedIn() ? "#7DA98D" : "white",
                                        borderRadius: "35px"
                                    }}
                                    onClick={() => {
                                        if (!verifyLoggedIn()) {
                                            nav("/login")
                                        }
                                        if (verifyLoggedIn()) {
                                            nav("/mentor/cabinet")
                                        }
                                    }}>
                                </AccountCircleIcon>
                            </OverlayTrigger>
                        </div>
                        <div className={Style.language}>
                            <TranslationSwitch></TranslationSwitch>
                        </div>
                    </div>

                    <div className={Style.textBlockContainer}>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            width: "100vw",
                        }}>
                            <h1 className={Style.textHeader}>LeelaOnline</h1>
                            <div className={Style.textBlock}>
                                {t('mainText')}
                                <br></br>
                            </div>
                        </div>
                        <div className={Style.controlBoxContainer}>
                            {controlBox(aboutPlatformPath, 2, t('platform'),
                                () => {
                                    document.getElementById("about_platform_block").scrollIntoView(true)
                                    sendEvent("click Platform", "click Platform")
                                })}
                            {controlBox(adImgUrl, 1, "",
                                () => {
                                    if (adFollowUrl) {
                                        traceAdClick(adId, ()=>{}, ()=>{console.error("Failed to trace ad click")})
                                        window.open(adFollowUrl, "_blank", "noopener")
                                    }


                            })}
                            {controlBox(allMentorsPath, 3, t('hosts'),
                                () => {
                                    document.getElementById("mentors_block").scrollIntoView(true)
                                    sendEvent("scroll to mentors section", "scroll to mentors section")
                                })}
                        </div>

                    </div>

                    <div className={Style.aboutContainer} id={"about_platform_block"}>
                        <div className={Style.aboutPlatformContainer}>
                            <div className={Style.imagesContainer}>
                                <div>
                                    <CasinoOutlinedIcon
                                        style={{height: "50px", width: "50px", color: "#4755A0"}}></CasinoOutlinedIcon>
                                    <h5>{t('builtInDice')}</h5>
                                </div>
                                <div>
                                    <VideoCameraFrontOutlinedIcon style={{
                                        height: "50px",
                                        width: "50px",
                                        color: "#4755A0"
                                    }}></VideoCameraFrontOutlinedIcon>
                                    <h5>{t('videoAudioConnection')}</h5>
                                </div>
                                <div>
                                    <InsertPhotoOutlinedIcon style={{
                                        height: "50px",
                                        width: "50px",
                                        color: "#4755A0"
                                    }}></InsertPhotoOutlinedIcon>
                                    <h5>
                                        <a className={Style.fieldsPreview} href={"/preview_field_styles_en"}
                                           target="_blank">
                                            {t('gameFieldsSelection')}
                                        </a>
                                    </h5>
                                </div>
                                <div>
                                    <FilterNoneOutlinedIcon style={{
                                        height: "50px",
                                        width: "50px",
                                        color: "#4755A0"
                                    }}></FilterNoneOutlinedIcon>
                                    <h5>{t('buildInMetCards')}</h5>
                                </div>
                            </div>
                            <ReactPlayer
                                playing={true}
                                muted={true}
                                loop={true}
                                url={"https://leela-online-videos.s3.eu-north-1.amazonaws.com/MainPage_AboutPlatform.mp4"}
                                controls={true} height={"80%"} width={"80%"}>
                                >
                            </ReactPlayer>
                        </div>
                        <div className={Style.buttonsSection}
                             onClick={() => sendEvent("click know more", "know more")}>
                            <a href={"https://www.instagram.com/leelaonline_net/?next=%2F"} target="_blank">
                                {t('knowMore')}
                            </a>
                        </div>

                    </div>

                    {mentors &&
                        <div className={Style.mentorsBlockContainer} id={"mentors_block"}>
                            <HandshakeOutlinedIcon
                                style={{
                                    marginTop: "24px",
                                    height: "50px",
                                    width: "50px",
                                    color: "#001649"
                                }}></HandshakeOutlinedIcon>
                            <h5 className={Style.mentorBlockHeader}>{t('ourMentors')}</h5>
                            <h5 className={Style.mentorBlockHeader}
                                style={{marginTop: "12px", color: "#001649", textShadow: "none"}}>{t('ourMostActiveMentors')}</h5>
                            <div className={Style.mentorsBlock}>
                                <MentorsCarousel mentors={mentors}></MentorsCarousel>
                            </div>
                            <div className={Style.buttonsSection}>
                                <a href={"/register"} target="_blank">
                                    {t('mentorsJoin')}
                                </a>
                                <a href={"/mentors"}
                                   onClick={() => sendEvent("open all mentors", "mentor section")}
                                   target="_blank">
                                    {t('allMentors')}
                                </a>
                            </div>
                        </div>}


                    <div className={Style.letsPlayContainer}>
                        <h5 style={{
                            textAlign: "center",
                            marginTop: "24px",
                            fontSize: "25px",
                            fontWeight: "bold",
                            color: "#36343E"
                        }}>{t('stillNotSure')}</h5>
                        <div className={Style.buttonsSection} onClick={() => setMetCard(true)}>
                            <a onClick={() => sendEvent("open mac card", "mac card")}>
                                {t('tipCard')}
                            </a>
                        </div>
                    </div>

                    <div style={{height: "100px"}}></div>

                    <div className={Style.bottomNavBar}>
                        <div className={Style.startPageMainContacts}>
                            <div>
                                <InfoOutlinedIcon style={{width: "40px", height: "40px"}}></InfoOutlinedIcon>
                                <a style={{color: "black"}} href="/agreement_en">{t('termsAndConditions')}</a>
                            </div>
                            <div>
                                <img alt={"Instagram logo"} src={instagram_logo} width={40} height={40}></img>
                                <a style={{color: "black"}} target="_blank"
                                   href={"https://www.instagram.com/leelaonline_net/"}
                                   rel="noreferrer"> leelaonline_net</a>
                            </div>
                            <div>
                                <MailOutlineIcon style={{width: "40px", height: "40px"}}></MailOutlineIcon>
                                <a style={{color: "black"}}
                                   href="mailto:support@leelaonline.net">support@leelaonline.net</a>
                            </div>
                        </div>
                        <div style={{height: "5px", overflow: "scroll", color: "lightgray"}}>{text}</div>

                    </div>
                    {
                        metCard && <MetaphoricCardsModalStartPage selectedStack={1}
                                                                  closeModal={() => setMetCard(false)}></MetaphoricCardsModalStartPage>
                    }
                </div>
            </>
        </>
    )
}

export default StartPageNew

const text = "Ласкаво просимо на leelaonline.net — платформу для гри Ліла онлайн\n" +
    "Ласкаво просимо на leelaonline.net — сучасний простір для тих, хто хоче грати в Ліла онлайн чи шукає досвідченого провідника Ліла. Наша місія — створити зручну платформу для гравців і провідників, щоб зануритись у трансформаційну гру, яка допомагає зрозуміти життєві уроки та духовні істини.\n" +
    "Leela Online — зручність для провідника гри Ліла\n" +
    "На leelaonline.net провідники отримують усі необхідні інструменти для ефективного проведення гри Ліла в онлайн-форматі. Наша платформа дозволяє налаштовувати процес гри під індивідуальні запити гравців, проводити сеанси в реальному часі та забезпечує підтримку на кожному етапі. Завдяки простому інтерфейсу провідники можуть зосередитися на глибині і змістовності гри.\n" +
    "Грайте в Ліла з Leela Online!\n" +
    "Грати в Ліла онлайн з досвідченим провідником — це унікальна можливість для кожного учасника. Незалежно від рівня підготовки, ця трансформаційна подорож стане важливим кроком на шляху самопізнання.\n" +
    "Долучайтесь до leelaonline.net — зробіть перший крок до глибокого розуміння себе та законів Всесвіту.\n" +
    "\n" +
    "Що таке гра Ліла?\n" +
    "Ліла — це древня трансформаційна гра, яка допомагає знайти відповіді на важливі життєві запитання.\n" +
    "З санскриту слово \"Ліла\" перекладається як \"гра\". Ця практика вчить нас дивитись на життя як на гру, сприймаючи кожну мить з відкритим серцем. Вона допомагає проникнути в глибини своєї внутрішньої мудрості та пізнати себе.\n" +
    "Як грати в Ліла?\n" +
    "Під час гри учасник кидає кубик, дозволяючи кармічним силам визначити наступний хід. Гравець проходить різні рівні існування, піднімаючись по стрілах і спускаючись по зміях, щоб осягнути істини свого вищого \"Я\".\n" +
    "Гра завершується, коли учасник досягає Космічної Свідомості, усвідомлюючи свою роль у Всесвіті.\n" +
    "\n" +
    "Хто такий провідник Ліла?\n" +
    "Провідник гри Ліла — це досвідчений наставник, який супроводжує гравця під час гри, створюючи безпечний простір для самопізнання. Провідник допомагає зрозуміти філософські аспекти гри, символізм її етапів та інтегрувати отримані уроки в повсякденне життя.\n" +
    "Роль провідника:\n" +
    "* Допомагати сформулювати намір для гри.\n" +
    "* Інтерпретувати значення клітинок і ситуацій гри.\n" +
    "* Підтримувати учасника у складних моментах.\n" +
    "* Сприяти духовному розвитку та розширенню свідомості.\n" +
    "Завдяки підтримці провідника гра Ліла стає потужним інструментом для самопізнання, роботи з кармою і життєвими уроками.\n" +
    "Чому обрати Leela Online?\n" +
    "* Простота у використанні платформи.\n" +
    "* Можливість грати в Ліла онлайн у будь-який час.\n" +
    "* Доступ до досвідчених провідників гри Ліла.\n" +
    "Долучайтесь до leelaonline.net і почніть свою трансформаційну подорож вже сьогодні!\n" +
    "\n" +
    "\n" +
    "Добро пожаловать на leelaonline.net — платформу для игры Лила онлайн\n" +
    "Добро пожаловать на leelaonline.net — современное пространство для тех, кто хочет играть в Лила онлайн или ищет опытного проводника Лила. Наша миссия — предоставить удобную платформу для игроков и проводников, чтобы погрузиться в трансформационную игру, которая помогает осознать жизненные уроки и духовные истины.\n" +
    "Leela Online — удобство для проводников игры Лила\n" +
    "На leelaonline.net проводники получают все необходимые инструменты для эффективного проведения игры Лила в онлайн-формате. Наша платформа позволяет адаптировать процесс игры под индивидуальные запросы игроков, проводить сеансы в реальном времени и предоставляет поддержку на всех этапах. Благодаря простому интерфейсу проводники могут сосредоточиться на глубине и содержательности игры.\n" +
    "Играйте в Лила с Leela Online!\n" +
    "Играть в Лила онлайн с опытным проводником — это уникальная возможность для каждого участника. Независимо от уровня подготовки, это трансформационное путешествие станет важным шагом на пути самопознания.\n" +
    "Присоединяйтесь к leelaonline.net — сделайте первый шаг к глубокому пониманию себя и законов Вселенной.\n" +
    "\n" +
    "Что такое игра Лила?\n" +
    "Лила — это древняя трансформационная игра, которая помогает найти ответы на важные жизненные вопросы.\n" +
    "С санскрита слово \"Лила\" переводится как \"игра\". Эта практика учит нас смотреть на жизнь как на игру, воспринимая каждый момент с открытым сердцем. Игра помогает заглянуть в глубины своей внутренней мудрости и познать себя.\n" +
    "Как играть в Лила?\n" +
    "Во время игры участник бросает кубик, позволяя кармическим силам определить следующий ход. Игрок проходит разные уровни существования, поднимаясь по стрелам и спускаясь по змеям, чтобы постичь истины своего высшего \"Я\".\n" +
    "Игра завершается, когда участник достигает Космического Сознания, осознавая свою роль во Вселенной.\n" +
    "\n" +
    "Кто такой проводник Лила?\n" +
    "Проводник игры Лила — это опытный наставник, который сопровождает игрока во время игры, создавая безопасное пространство для самопознания. Проводник помогает понять философские аспекты игры, символизм её этапов и интегрировать полученные уроки в повседневную жизнь.\n" +
    "Роль проводника:\n" +
    "* Помогать сформулировать намерение для игры.\n" +
    "* Интерпретировать значения клеток и игровых ситуаций.\n" +
    "* Поддерживать участника в сложные моменты.\n" +
    "* Способствовать духовному развитию и расширению сознания.\n" +
    "Благодаря поддержке проводника игра Лила становится мощным инструментом для самопознания, работы с кармой и жизненными уроками.\n" +
    "Почему выбрать Leela Online?\n" +
    "* Простота использования платформы.\n" +
    "* Возможность играть в Лила онлайн в любое время.\n" +
    "* Доступ к опытным проводникам игры Лила.\n" +
    "Присоединяйтесь к leelaonline.net и начните своё трансформационное путешествие уже сегодня!\n" +
    "\n" +
    "Welcome to leelaonline.net — The Platform for Playing Lila Online\n" +
    "Welcome to leelaonline.net, a modern space for those who want to play Lila online or are seeking an experienced Lila guide. Our mission is to provide a convenient platform for players and guides to immerse themselves in this transformational game, which helps uncover life lessons and spiritual truths.\n" +
    "Leela Online — Convenience for Lila Guides\n" +
    "On leelaonline.net, guides receive all the tools they need to conduct Lila games effectively in an online format. Our platform allows guides to customize the game process according to the individual needs of players, conduct real-time sessions, and offers support at every stage. With its user-friendly interface, guides can focus on the depth and meaning of the game.\n" +
    "Play Lila with Leela Online!\n" +
    "Playing Lila online with an experienced guide is a unique opportunity for every participant. Regardless of your level of preparation, this transformational journey will be a significant step toward self-awareness.\n" +
    "Join leelaonline.net and take your first step toward a deeper understanding of yourself and the laws of the universe.\n" +
    "\n" +
    "What is the Lila Game?\n" +
    "Lila is an ancient transformational game that helps you find answers to life’s most important questions.\n" +
    "In Sanskrit, the word \"Lila\" means \"game.\" This practice teaches us to view life as a game, embracing each moment with an open heart. The game helps you delve into the depths of your inner wisdom and discover yourself.\n" +
    "How Do You Play Lila?\n" +
    "During the game, the participant rolls a dice, allowing karmic forces to determine their next move. The player journeys through various planes of existence, ascending with arrows and descending with snakes, aiming to uncover the truths of their higher self.\n" +
    "The game concludes when the participant attains Cosmic Consciousness and realizes their role in the universe.\n" +
    "\n" +
    "Who is a Lila Guide?\n" +
    "A Lila game guide is an experienced mentor who accompanies the player during the game, creating a safe space for self-discovery. The guide helps interpret the philosophical aspects of the game, the symbolism of its stages, and integrates the lessons learned into everyday life.\n" +
    "The role of the guide includes:\n" +
    "* Helping to formulate the player’s intent for the game.\n" +
    "* Interpreting the meanings of cells and game scenarios.\n" +
    "* Supporting the player during challenging moments.\n" +
    "* Facilitating spiritual growth and expanded awareness.\n" +
    "With the guidance of a skilled mentor, the Lila game becomes a powerful tool for self-discovery, working with karma, and understanding life’s lessons.\n" +
    "\n" +
    "Why Choose Leela Online?\n" +
    "* Easy-to-use platform.\n" +
    "* The ability to play Lila online anytime.\n" +
    "* Access to experienced Lila guides.\n" +
    "Join leelaonline.net and begin your transformational journey today!"
